import { render, staticRenderFns } from "./ClipboardBtn.vue?vue&type=template&id=510b52cb&scoped=true"
import script from "./ClipboardBtn.vue?vue&type=script&lang=js"
export * from "./ClipboardBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b52cb",
  null
  
)

export default component.exports